export enum LotFormMode {
    Add,
    Update,
    BulkUpdate,
    ReadOnly,
    BulkAdd
}